
export default {
  activity: '/activity/{{suffix:0}}/{{suffix:1}}',
  program: '/explore/program/{{suffix:0}}',
  search: {
    noSuffix: '/explore/search',
    suffix: '/explore/search/{{suffix:0}}'
  },
  home: '/home',
  contact: 'https://mystrength.com/contact',
  help: '/help-resources'
};
